const CheckoutTypes = {
  START_CARD_CHECKOUT: 'START_CARD_CHECKOUT',
  START_BANK_SLIP_CHECKOUT: 'START_BANK_SLIP_CHECKOUT',
  SUCCESS_CHECKOUT: 'SUCCESS_CHECKOUT',
  FAILURE_CHECKOUT: 'FAILURE_CHECKOUT',
};

export default CheckoutTypes;
